'use client'

import { navigateToPage } from '@marketplace-web/shared/browser'
import { clickEvent } from '_libs/common/event-tracker/events'

import { ITEM_UPLOAD_URL } from 'constants/routes'
import { ClickableElement } from 'constants/tracking/clickable-elements'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'
import { ApplicableTransactionAction } from '@marketplace-web/domain/conversation-messaging-data'

import useTransactionActions from '../../hooks/useTransactionActions/useTransactionActions'

type Props = ConversationActionProps

const UploadItem = ({ title, primary, size, theme, inverse }: Props) => {
  const { track } = useTracking()

  const { conversation } = useConversationContext()

  const transactionId = conversation?.transactionId
  const userSide = conversation?.transaction?.userSide
  const shipmentStatus = conversation?.transaction?.shipment?.status
  const transactionStatus = conversation?.transaction?.status
  const { applicableTransactionActions } = useTransactionActions()

  const trackButtonClick = () => {
    if (!transactionId) return

    const isFeedbackActionAvailable =
      applicableTransactionActions.includes(ApplicableTransactionAction.LeaveFeedback) || false

    const targetDetails: Record<string, unknown> = {
      user_side: userSide,
      transaction_id: transactionId,
      shipment_status: shipmentStatus,
      transaction_status: transactionStatus,
      is_feedback_action_available: isFeedbackActionAvailable,
    }

    track(
      clickEvent({
        target: ClickableElement.UploadItem,
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const handleClick = () => {
    trackButtonClick()

    navigateToPage(ITEM_UPLOAD_URL)
  }

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
    />
  )
}

export default UploadItem
